/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReportParameterType } from './ReportParameterType';
import {
    ReportParameterTypeFromJSON,
    ReportParameterTypeFromJSONTyped,
    ReportParameterTypeToJSON,
    ReportParameterTypeToJSONTyped,
} from './ReportParameterType';

/**
 * 
 * @export
 * @interface GetReportParameter
 */
export interface GetReportParameter {
    /**
     * 
     * @type {string}
     * @memberof GetReportParameter
     */
    name: string;
    /**
     * 
     * @type {ReportParameterType}
     * @memberof GetReportParameter
     */
    parametarType: ReportParameterType;
    /**
     * 
     * @type {boolean}
     * @memberof GetReportParameter
     */
    isRequired: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetReportParameter
     */
    defaultValue: string | null;
}



/**
 * Check if a given object implements the GetReportParameter interface.
 */
export function instanceOfGetReportParameter(value: object): value is GetReportParameter {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('parametarType' in value) || value['parametarType'] === undefined) return false;
    if (!('isRequired' in value) || value['isRequired'] === undefined) return false;
    if (!('defaultValue' in value) || value['defaultValue'] === undefined) return false;
    return true;
}

export function GetReportParameterFromJSON(json: any): GetReportParameter {
    return GetReportParameterFromJSONTyped(json, false);
}

export function GetReportParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReportParameter {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'parametarType': ReportParameterTypeFromJSON(json['parametarType']),
        'isRequired': json['isRequired'],
        'defaultValue': json['defaultValue'],
    };
}

export function GetReportParameterToJSON(json: any): GetReportParameter {
    return GetReportParameterToJSONTyped(json, false);
}

export function GetReportParameterToJSONTyped(value?: GetReportParameter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'parametarType': ReportParameterTypeToJSON(value['parametarType']),
        'isRequired': value['isRequired'],
        'defaultValue': value['defaultValue'],
    };
}

